import { IStore } from '../../reducers/index'

const userIdSelector = (state: IStore) => state.app.playerUID

export default userIdSelector
